import Load from 'components/Load';
import React from 'react';
import { Route } from 'react-router-dom';
import basePath from 'utils/basePath';

const AsyncConfirmation = Load(
  () =>
    import(
      /* webpackChunkName: "confirmation-page" */ './ConfirmationChildRoutes'
    ),
);
function renderAsyncConfirmation(props) {
  return <AsyncConfirmation key="confirmation" {...props} />;
}

const ConfirmationRoute = (
  <Route
    key="confirmation"
    path={`${basePath}/confirmation/:paymentId`}
    render={renderAsyncConfirmation}
  />
);

export default ConfirmationRoute;
